export const fallbackLng = 'en';
